<template>
  <v-dialog v-model="dialogAppointment" persistent max-width="600">
    <v-card>
      <v-card-title class="text-h7">
        ¿Desea enviar a somatometría?
      </v-card-title>
      <v-card-text>
        Antes de ser atendido, el paciente deberá pasar a somatometría.
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-container>
            <v-row>
              <v-col class="text-left" md="4">
                <v-btn
                  outlined
                  @click="
                    flag = false;
                    dialogClose();
                    addDate();
                  "
                  color="warning"
                >
                  No, omitir <v-icon right>mdi-skip-next</v-icon>
                </v-btn>
              </v-col>

              <v-col class="text-right" md="4" offset-md="4">
                <v-btn
                  color="primary"
                  outlined
                  @click="
                    flag = true;
                    dialogClose();
                    addDate();
                  "
                  >Sí, continuar <v-icon right>mdi-check</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-spacer></v-spacer>
            <v-row>
              <v-spacer></v-spacer>
              <v-row>
                <v-col class="text-center" md="4">
                  <v-btn plain @click="dialogClose()" color="error">
                    Regresar <v-icon right>mdi mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
          </v-container>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    addDate: Function,
    dialogAppointment: Boolean,
    objAltaPaciente: {
      type: Array,
    },
  },
  data() {
    return {
      sometometryChoose: Boolean,
      flag: false,
    };
  },
  watch: {
    flag: function() {
      this.$emit("changeSometometry", this.flag);
    },
  },
  methods: {
    sometryChoose() {
      if (flag) {
        this.sometometryChoose = true;
        this.$emit("changeSometometry", flag);
      } else {
        this.sometometryChoose = false;
        this.$emit("changeSometometry", this.sometometryChoose);
      }
    },
    dialogClose() {
      let closeDialogAppointment = false;
      this.$emit("changeSometometry", this.flag);
      this.$emit("dialogClose", closeDialogAppointment);
    },
  },
};
</script>
